import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { SlideMenu } from 'primeng/slidemenu';

@Injectable({
  providedIn: 'root'
})

export class MenuService {
  public isMenuOpen: boolean;
  public configObservable = new Subject<boolean>();
  private _menu: SlideMenu;

  public get menu(): SlideMenu {
    return this._menu;
  }

  public set menu(slideMenu: SlideMenu) {
    this._menu = slideMenu;
  }

  public emitMenuService(isMenuOpen: boolean) {
    this.isMenuOpen = isMenuOpen;
  }

  public emitCloseMenu() {
    this.configObservable.next(this.isMenuOpen);
  }
}
